import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 20H3C2.45 20 2 19.55 2 19V5C2 4.45 2.45 4 3 4H21C21.55 4 22 4.45 22 5V19C22 19.55 21.55 20 21 20ZM4 18H20V6H4V18Z" fill={ fill || 'currentColor' } />
        <path d="M12 16H6L10.79 10L13.7 13.81L14.98 12.17L17.99 15.98H11.99L12 16ZM6 9.32C6 8.59 6.6 8 7.32 8C8.04 8 8.64 8.6 8.64 9.32C8.64 10.04 8.04 10.64 7.32 10.64C6.6 10.64 6 10.04 6 9.32Z" fill={ fill || 'currentColor' } />
    </svg>
);
